import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  inject,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { Product } from "../../models";
import { CompProductFacade } from "../../services/comp-product-facade";
import { ProductFacade, SelectedProduct } from "../../services/product-facade";
import { RandomItemComponent } from "./quantity-item/random-item/random-item.component";
import { FixedItemComponent } from "./quantity-item/fixed-item/fixed-item.component";
import { SpecificItemComponent } from "./quantity-item/specific-item/specific-item.component";
import { ButtonComponent } from "@progress/kendo-angular-buttons";
import { AsyncPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-quantity-step",
  templateUrl: "./quantity-step.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RandomItemComponent,
    FixedItemComponent,
    SpecificItemComponent,
    ButtonComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class QuantityStepComponent implements OnInit, OnDestroy {
  private compProductFacade = inject(CompProductFacade);
  productFacade = inject(ProductFacade);
  private   cdr = inject(ChangeDetectorRef);
  private subscriptions = new Subscription();

  parts$: Observable<Product[]>;

  selectedProductForm = new FormGroup({
    qtyType: new FormControl(""),
    partNum: new FormControl(""),
    partDesc: new FormControl(""),
    isMaibecExpress: new FormControl(false),
    uD_CodeFinish_c: new FormControl(""),
    sellingUOM: new FormControl(""),
    sellingUOMDesc: new FormControl(""),
    qty: new FormControl(0),
    totalDefaultUOMQty: new FormControl(0),
    totalSellingQty: new FormControl(0),
    scrap: new FormControl(0),
    quantities: new FormArray([]),
    comment: new FormControl(""),
  });
    parts: Product[];

  constructor() {
    this.parts$ = this.productFacade.parts$;
    this.parts$.subscribe(parts => {          
        this.parts = parts;
        });
  }

  ngOnInit(): void {
    this.productFacade.fetchPartsForQty();
  }
  ngAfterViewInit(): void {
     this.cdr.detectChanges();
     console.log("QuantityStepComponent: ngAfterViewInit")
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  goToCompProductStep(): void {
    this.productFacade.updateSelectedMainProduct(
      this.selectedProductForm.value as SelectedProduct,
    );
    this.compProductFacade.showRootCompProductStep(
      this.selectedProductForm.value.partNum,
      this.selectedProductForm.value.totalDefaultUOMQty,
    );
  }
  
  disableNextStep(): boolean {  
    const selectedPart = this.selectedProductForm.value.partNum;
    return (
      this.selectedProductForm.invalid ||
      selectedPart === "" ||
      (selectedPart !== "" &&
        this.selectedProductForm.controls.totalSellingQty.value === 0)
    );
  }
}
